import {html} from 'lit';
import componentStyles from './video-vimeo.css.lit.ts';
import {OutlineElement} from '../../base/outline-element/outline-element.ts';
import Player from '@vimeo/player';

export default class VimeoVideo extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      id: {type: Number},
      hash: {type: String},
    };
  }

  constructor() {
    super();
    this.id = ''
    this.hash = ''
    this.url = ''
    this.title = ''
    this.firedProgressEvent = {
      10: false,
      25: false,
      50: false,
      75: false,
      90: false,
    }
  }

  formatEventName(eventName) {
    if (eventName === 'ended') {
      return "Complete";
    } else {
      return eventName.charAt(0).toUpperCase() + eventName.slice(1)
    }
  }

  getProgress(data) {
    return Math.trunc(data.percent * 100)
  }

  needProgressEvent(data) {
    const currentProgress = this.getProgress(data)
    const progressValueToSend = Object.keys(this.firedProgressEvent).find((key) => this.firedProgressEvent[key] === false);

    if (!progressValueToSend) {
      return false;
    }

    if (currentProgress >= progressValueToSend) {
      this.firedProgressEvent[progressValueToSend] = true;
      return progressValueToSend;
    }

    return false;
  }

  fireEvent(eventName, data) {
    const needToSendProgressValue = eventName === 'progress' ? this.needProgressEvent(data) : true
    const dataLayerData = {
      videoTitle: this.title,
      videoSource: this.url,
      videoAction: this.formatEventName(eventName),
      Progress: eventName === 'progress' ? needToSendProgressValue : this.getProgress(data)
    };

    if (eventName !== 'progress' || needToSendProgressValue) {
      window.dispatchEvent(
        new CustomEvent
        (
          'hf-video-gtm-event',
          {
            detail: {
              dataLayerData,
            },
          }
        )
      );
    }
  }

  firstUpdated() {
    this.url = `https://player.vimeo.com/video/${this.id}?h=${this.hash}`
    const iframe = this.shadowRoot.querySelector('iframe');
    const player = new Player(iframe);

    player.on('play', (data) => this.fireEvent('play', data));
    player.on('pause', (data) => this.fireEvent('pause', data));
    player.on('ended', (data) => this.fireEvent('ended', data));
    player.on('progress', (data) => this.fireEvent('progress', data));

    player.getVideoTitle().then(title => this.title = title);
  }

  render() {
    return html`
      <div class="video video--vimeo">
        <iframe
          src="https://player.vimeo.com/video/${this.id}?h=${this.hash}"
          width="480px"
          height="270px"
          frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen>
        </iframe>
      </div>`;
  }
}

customElements.define('hf-video-vimeo', VimeoVideo);
